import axios from "axios";
import router from '@/router'
import { message } from 'ant-design-vue';
import store from '@/store'
//console.log(process.env)
const http = axios.create({
    timeout: 3000,
    baseURL: process.env.VUE_APP_URL,
    //此处开启后请求报错
    //withCredentials: true // axios请求开启cookie，支持跨域请求携带cookie
});
//请求拦截器
http.interceptors.request.use(config => {
    if (store.getters['User/token']) {
        config.headers['Authorization'] = 'Bearer ' + store.getters['User/token'];
    }
    return config;
}, error => {
    return Promise.reject(error);
});
//响应拦截器
http.interceptors.response.use(response => {
    if (response.data.code == 1) {
        return Promise.resolve(response.data);
    } else {
        message.error(response.data.msg);
        return Promise.reject(response.data.msg);
    }
}, error => {
    if (error.response) {
        message.error(error.response.data.msg);
        if (error.response.status === 401) {
            router.push({
                path: `/login`
            })
        }
        return Promise.reject(error)
    } else {
        message.error('请求超时, 请刷新重试');
        return Promise.reject(new Error('请求超时, 请刷新重试'))
    }

})

export default http;
